import { STATUS_LABEL, STATUS_CLASS } from "@/lib/constants";

export default function StatusBadge({ status, cancellationReason }) {
  // Special-case: KYC-rejected transactions are shown as "Pièce refusée" instead of generic "Annulé"
  const isKycRejected = status === "annule" && cancellationReason === "kyc_rejected";
  const label = isKycRejected ? "Pièce refusée" : (STATUS_LABEL[status] || status);
  const cls = STATUS_CLASS[status] || "sl-badge sl-badge-pending";
  const testId = isKycRejected ? "status-badge-kyc-rejected" : `status-badge-${status}`;
  return (
    <span className={cls} data-testid={testId}>
      {label}
    </span>
  );
}
